var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 7,
    viewBox: "0 0 20 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "system-path",
    d: "M15.012 6.7C15.292 6.10267 15.5627 5.58 15.824 5.132C16.104 4.684 16.3747 4.31067 16.636 4.012H0.312V2.836H16.636C16.3747 2.51867 16.104 2.136 15.824 1.688C15.5627 1.24 15.292 0.726666 15.012 0.147999H15.992C17.168 1.51067 18.4 2.51867 19.688 3.172V3.676C18.4 4.31067 17.168 5.31867 15.992 6.7H15.012Z",
    fill: "#152946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDates);
export default __webpack_public_path__ + "static/media/arrow-dates.80a6a3be076bfaa2bdae51400f90c6fb.svg";
export { ForwardRef as ReactComponent };